
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M38.5 27.68l-25-25C12.32 1.5 8.9 1.5 8.9 1.5s0 3.42 1.1 4.55L35 31.1zM23.7 12.88a2.42 2.42 0 00-3.42 3.42M24.84 20.85l3.41-3.41M31.1 35.08l-25-25C4.92 8.9 1.5 8.9 1.5 8.9s0 3.42 1.14 4.55l25 25.05zM16.3 20.28a2.42 2.42 0 00-3.42 3.42M17.44 28.25l3.41-3.41","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}}),_c('path',{attrs:{"d":"M18.85 29.71c-2.55 3-3.29 4.42-5.56 6.7a6.86 6.86 0 01-9.7-9.7c2.28-2.28 3.7-3 6.72-5.58M26 22.23c-.58.57-1.22 1.19-1.9 1.87s-1.37 1.38-2 2M21.32 10.08c2.42-2.86 3.17-4.26 5.39-6.49a6.86 6.86 0 019.7 9.7c-2.27 2.27-3.69 3-6.67 5.54M14.12 17.65l1.78-1.75c.66-.66 1.26-1.28 1.81-1.85M32.78 2.13v13.93M7.45 23.66v14.57","fill":"none","stroke":"#241f21","stroke-miterlimit":"10","stroke-width":"2"}})])
          )
        }
      }
    